import Vue from 'vue'

Vue.directive('validator', {
  // isLiteral: true,
  bind: function (el, binding) {
    if (!binding.value) { return }
    el.addEventListener("keypress", ($event) => {
      const key = String.fromCharCode($event.which || $event.charCode);
      const text = $event.target.value + key
      if ($event.target && !binding.value.test(text)) {
        $event.preventDefault()
      }
    })
  }
})